import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b578d5bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-10" }
const _hoisted_2 = { class: "row align-items-top desktop" }
const _hoisted_3 = { class: "fs-1" }
const _hoisted_4 = { class: "mt-2 mb-8 fs-4" }
const _hoisted_5 = { class: "col-lg-6 col-md-12" }
const _hoisted_6 = { class: "my-5 fs-3 fw-bold" }
const _hoisted_7 = {
  class: "accordion accordion-icon-toggle",
  id: "kt_accordion_cursos"
}
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = { class: "accordion-icon" }
const _hoisted_10 = { class: "fs-4 fw-semibold mb-0 ms-4" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "col-lg-6 col-md-12" }
const _hoisted_14 = { class: "my-5 fs-3 fw-bold" }
const _hoisted_15 = {
  class: "accordion accordion-icon-toggle",
  id: "kt_accordion_iam"
}
const _hoisted_16 = ["data-bs-target"]
const _hoisted_17 = { class: "accordion-icon" }
const _hoisted_18 = { class: "fs-4 fw-semibold mb-0 ms-4" }
const _hoisted_19 = ["id"]
const _hoisted_20 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BIconArrowRightSquare = _resolveComponent("BIconArrowRightSquare")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("preguntasFrecuentes")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("introFAQs")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("sobreCursos")), 1),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqsCursos, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'curso-' + index,
              class: "mb-5"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["accordion-header py-3 d-flex", { collapsed: index !== 0 }]),
                "data-bs-toggle": "collapse",
                "data-bs-target": '#kt_accordion_cursos_item_' + index,
                style: {"cursor":"pointer"}
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_BIconArrowRightSquare, { class: "fs-1 fw-bold" })
                ]),
                _createElementVNode("h3", _hoisted_10, _toDisplayString(item.pregunta), 1)
              ], 10, _hoisted_8),
              _createElementVNode("div", {
                id: 'kt_accordion_cursos_item_' + index,
                class: _normalizeClass(["fs-6 collapse ps-10", { show: index === 0 }]),
                "data-bs-parent": "#kt_accordion_cursos"
              }, [
                _createElementVNode("div", {
                  innerHTML: item.respuesta,
                  class: "faq-respuesta"
                }, null, 8, _hoisted_12)
              ], 10, _hoisted_11)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("sobreIAM")), 1),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqsIam, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'iam-' + index,
              class: "mb-5"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["accordion-header py-3 d-flex", { collapsed: index !== 0 }]),
                "data-bs-toggle": "collapse",
                "data-bs-target": '#kt_accordion_iam_item_' + index,
                style: {"cursor":"pointer"}
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_BIconArrowRightSquare, { class: "fs-1 fw-bold" })
                ]),
                _createElementVNode("h3", _hoisted_18, _toDisplayString(item.pregunta), 1)
              ], 10, _hoisted_16),
              _createElementVNode("div", {
                id: 'kt_accordion_iam_item_' + index,
                class: _normalizeClass(["fs-6 collapse ps-10", { show: index === 0 }]),
                "data-bs-parent": "#kt_accordion_iam"
              }, [
                _createElementVNode("div", {
                  innerHTML: item.respuesta,
                  class: "faq-respuesta"
                }, null, 8, _hoisted_20)
              ], 10, _hoisted_19)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}